module.exports = __webpack_public_path__ + "static/media/fg_my.60ccf5d2.png";